/* eslint-disable jsx-a11y/no-static-element-interactions */
import React, { Component } from 'react';
import Skeleton from 'react-loading-skeleton';
import DefaultProfile from '../../assets/profile/default-profile-icon.svg';
import './styles.scss';

export class Matches extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: true,
    };
  }

  async componentDidMount() {
    await this.props.getUsers(this.props.user.userType);
    await this.props.getMatches();
    const promises = Object.entries(this.props.users).map(([email, user]) => {
      return this.props.getProfilePhoto(
        user.answers?.profile_photo?.answer,
        email,
      );
    });
    await Promise.all(promises);
    this.setState({ loading: false });
  }

  getProfilePhoto = (url) => {
    if (!url) {
      return <div className="profile-box-pic" style={{ backgroundImage: `url(${DefaultProfile})` }} />;
    }
    if (!url.startsWith('http')) {
      return (
        <div className="profile-box-pic">
          <Skeleton height="100%" width="100%" />
        </div>
      );
    } else {
      return <div className="profile-box-pic" style={{ backgroundImage: `url(${url})` }} />;
    }
  }

  renderTile = (email) => {
    const user = this.props.users[email];
    const { answers, name } = user;
    const year = answers.year_of_graduation.answer;
    const location = this.props.user.userType === 1 ? answers.house?.answer : answers.location?.answer;
    const profilePic = answers?.profile_photo?.answer;
    return (
      <div
        className="profile-box"
        key={email}
        onClick={() => this.props.goToProfile(this.props.history, email, this.goToMatches)}
      >
        {this.getProfilePhoto(profilePic)}
        <div className="profile-box-bottom">
          <div className="profile-box-name">{name}</div>
          <div className="profile-box-year-house">{year} - {location}</div>
        </div>
      </div>
    );
  }

  // explicitly defining this function makes it easier to test
  goToMatches = () => {
    this.props.history.push('/matches');
  }

  render() {
    return (
      <div className="matches-full-page">
        <div className="right-side2">
          <div className="top-bar">
            <div className="top-bar-new">{Object.keys(this.props.usersRecip).length} Matches</div>
            <div className="top-bar-section">{this.props.numRequests} Requests </div>
          </div>
          <div className="main">
            {this.state.loading
              ? <div id="circle2" />
              : Object.keys(this.props.usersRecip)
                .filter(email => (Object.keys(this.props.users).includes(email)))
                .map(this.renderTile)
            }
          </div>
        </div>
      </div>
    );
  }
}

export default Matches;
